import { Store, ClipboardList, Megaphone, CalendarHeart } from "lucide-react";

export const BUSINESS_TABS = [
  { id: "listings", label: "Activities / Venue listings", short: "Listings", icon: Store },
  { id: "noticeboard", label: "Noticeboard listings", short: "Noticeboard", icon: ClipboardList },
  { id: "ads", label: "Ads", short: "Ads", icon: Megaphone },
  { id: "meetups", label: "Meet-ups", short: "Meet-ups", icon: CalendarHeart },
] as const;

export type BusinessTab = (typeof BUSINESS_TABS)[number]["id"];

export type BusinessView = BusinessTab | "profile" | "settings" | "messages";

export const isBusinessTab = (v: string | null): v is BusinessView =>
  v === "profile" || v === "settings" || v === "messages" || (!!v && BUSINESS_TABS.some((t) => t.id === v));
